import { render, staticRenderFns } from "./SingleSelectedBranch.vue?vue&type=template&id=a4f9024c&scoped=true&"
import script from "./SingleSelectedBranch.vue?vue&type=script&lang=js&"
export * from "./SingleSelectedBranch.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectedBranch.vue?vue&type=style&index=0&id=a4f9024c&scoped=true&lang=css&"
import style1 from "./SingleSelectedBranch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9024c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
